import { roleService } from "@/services";
import { useMutation, useQueryClient } from "@tanstack/react-query";


export const roleKeys = {
  all: ['roles'],
  single: (id) => [...roleKeys.all, id],
};

export const useCreateRole = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => roleService.createRole(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: roleKeys.all });
    },
    ...options,
  });
};

export const useUpdateRole = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => roleService.updateRole(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: roleKeys.single(id) });
      queryClient.invalidateQueries({ queryKey: roleKeys.all });
    },
    ...options,
  });
};

export const useDeleteRole = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => roleService.deleteRole(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: roleKeys.all });
    },
    ...options,
  });
}; 